(() => {
  'use strict';
  const configNode = document.getElementById('bwl-config');
  if (!configNode || window.bowlsILoveLoaded) return;
  window.bowlsILoveLoaded = true;
  const c = JSON.parse(configNode.textContent), t = c.strings;
  const KEY = 'sacred-sound.bowls-i-love.guest.v1';
  const heart = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M20.8 4.7a5.5 5.5 0 0 0-7.8 0L12 5.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.5a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
  const root = c.root.endsWith('/') ? c.root : c.root + '/';
  const listURL = new URL(c.listPath, location.origin);
  if (c.preview) listURL.searchParams.set('preview_theme_id', c.themeId);
  let items = [], guestMemory = [], authenticated = false, storageFailed = false, renderVersion = 0, undoItem = null, syncing = false, connecting = false, retrySaving = false;
  const account = c.syncEnabled ? window.bowlsILoveAccount : null;
  let accountMode = Boolean(account?.hasSession());
  const cache = new Map();
  let queue = Promise.resolve();
  const el = (tag, cls, text) => { const node = document.createElement(tag); if (cls) node.className = cls; if (text !== undefined) node.textContent = text; return node; };
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  const normalize = value => Array.isArray(value) ? value.filter(x => x && /^\d+$/.test(String(x.productId)) && /^\d+$/.test(String(x.variantId)) && validHandle(x.handle)).filter((x, i, a) => a.findIndex(y => String(y.variantId) === String(x.variantId)) === i).slice(0,100) : [];
  function readGuest() { try { guestMemory = normalize(JSON.parse(localStorage.getItem(KEY) || '[]')); } catch { storageFailed = true; } return guestMemory.slice(); }
  function writeGuest(value = items) { if (authenticated || accountMode) return; guestMemory = value.slice(); try { localStorage.setItem(KEY, JSON.stringify(guestMemory)); } catch { storageFailed = true; notice(t.storage_error); } }
  function productURL(item) { const u = new URL(root + 'products/' + item.handle, location.origin); u.searchParams.set('variant', item.variantId); if(c.preview) u.searchParams.set('preview_theme_id', c.themeId); return u.href; }
  function safeImage(value) { try { const u = new URL(value, location.origin); return u.protocol === 'https:' && (u.hostname === location.hostname || u.hostname === 'cdn.shopify.com' || u.hostname.endsWith('.shopifycdn.com')) ? u.href : null; } catch { return null; } }
  function notice(message, undo = false) { const box = document.getElementById('bwl-notice'); if(!box) return; box.querySelector('[data-bwl-message]').textContent = message; box.querySelector('[data-bwl-undo]').hidden = !undo; box.hidden = false; }
  function syncMessage(message, error) { const node = document.querySelector('[data-bwl-sync-message]'); if(node) { node.textContent = message; node.hidden = false; if(error?.code && /^[A-Z_]+$/.test(error.code))node.dataset.bwlSyncError=error.code;else delete node.dataset.bwlSyncError; } else notice(message); }
  function listText() { return t.list_title+'\n\n'+items.map(x=>`${x.sku || x.productId}: ${x.title}\n${new URL(root+'products/'+x.handle,location.origin).href}`).join('\n\n'); }
  function updateCopy() {
    document.querySelectorAll('[data-bwl-copy]').forEach(button => { button.disabled = !items.length || syncing; });
    const panel=document.querySelector('[data-bwl-copy-fallback]'),field=document.getElementById('bwl-copy-text');
    if(panel && field && !panel.hidden){field.value=items.length ? listText() : '';if(!items.length)panel.hidden=true;}
  }
  async function copyList() {
    if(!items.length || syncing)return;
    const text=listText(),panel=document.querySelector('[data-bwl-copy-fallback]'),field=document.getElementById('bwl-copy-text');
    try {
      if(typeof navigator.clipboard?.writeText!=='function')throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(text);
      if(panel)panel.hidden=true;if(field)field.value='';
      notice(t.copy_done);
    } catch {
      if(!items.length || syncing || text!==listText())return;
      if(panel && field){
        field.value=text;panel.hidden=false;
        const box=document.getElementById('bwl-notice');if(box)box.hidden=true;
        field.focus();field.select();field.scrollTop=0;field.scrollIntoView({block:'center'});
      } else notice(t.copy_error);
    }
  }
  function updateButtons() {
    document.querySelectorAll('[data-bwl-count]').forEach(node => { node.textContent = items.length; node.setAttribute('data-bwl-count', String(items.length)); });
    document.querySelectorAll('[data-bwl-save]').forEach(button => {
      const selected = items.some(x => x.handle === button.dataset.bwlSave);
      button.setAttribute('aria-pressed', String(selected));
      if(syncing) button.disabled = true;
      button.setAttribute('aria-label', selected ? t.remove : t.save);
      button.title = selected ? t.remove : t.save;
      const label = button.querySelector('[data-bwl-button-label]'); if(label) label.textContent = selected ? t.saved : t.save;
    });
    document.querySelectorAll('[data-bwl-list-link]').forEach(a => a.href = listURL.href);
    document.querySelectorAll('[data-bwl-storage]').forEach(node => node.textContent = authenticated ? t.saved_account : accountMode ? t.sign_in_needed : t.saved_device);
    document.querySelectorAll('[data-bwl-signin]').forEach(node => { node.hidden = authenticated; });
    document.querySelectorAll('[data-bwl-signout]').forEach(node => { node.hidden = !authenticated && !accountMode; });
    document.querySelectorAll('[data-bwl-retry-save]').forEach(node => { node.hidden = !retrySaving; node.disabled = syncing; });
    document.querySelectorAll('[data-bwl-account-copy]').forEach(node => { node.textContent = authenticated ? t.account_body : t.keep_body; });
    document.querySelectorAll('[data-bwl-account-title]').forEach(node => { node.textContent = authenticated ? t.account_title : t.keep_title; });
    updateCopy();
  }
  async function getProduct(handle, fresh = false) {
    if(!validHandle(handle)) throw new Error('Invalid product');
    if(!fresh && cache.has(handle)) return cache.get(handle);
    const request = fetch(root + 'products/' + handle + '.js', {credentials:'same-origin', cache:'no-store'}).then(async response => {
      if(response.status === 404) return null;
      if(!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      if(!product.id || !Array.isArray(product.variants)) throw new Error('Invalid product');
      return product;
    });
    cache.set(handle, request);
    try { return await request; } catch(error) { cache.delete(handle); throw error; }
  }
  function snapshot(product, variant) { return {productId:String(product.id),variantId:String(variant.id),handle:product.handle,sku:String(variant.sku || ''),title:product.title,image:product.featured_image || product.images?.[0] || '',savedAt:new Date().toISOString()}; }
  async function api(method='GET', body) {
    if(!account)throw new Error('Account connection unavailable');
    try {
      const data=await account.request(method,body);
      if(!Array.isArray(data.items))throw new Error('Invalid saved list');
      return data;
    } catch(error) {
      if(error.code==='SIGN_IN_REQUIRED'){authenticated=false;items=[];undoItem=null;updateButtons();render();}
      throw error;
    }
  }
  async function change(op, item) {
    if(accountMode && !authenticated) await loadAccount();
    if(authenticated) {
      const data = await api('POST', {op, item});
      items = normalize(data.items);
    } else {
      items = readGuest();
      if(op === 'add' && !items.some(x=>x.variantId===item.variantId)) { if(items.length>=100) {const error=new Error('LIST_FULL');error.code='LIST_FULL';throw error;} items.unshift(item); }
      if(op === 'remove') items = items.filter(x=>x.variantId!==item.variantId);
      writeGuest();
    }
    updateButtons();
    await render();
  }
  function schedule(fn) { const task = queue.then(fn); queue = task.catch(()=>{}); return task; }
  async function toggle(button) {
    button.disabled = true;
    try { await schedule(async () => {
      const handle = button.dataset.bwlSave, saved = items.find(x=>x.handle===handle);
      if(saved) { await change('remove',saved); undoItem = saved; notice(t.removed,true); return; }
      const product = await getProduct(handle,true);
      if(!product) throw new Error('Missing product');
      const specified = button.dataset.bwlVariant;
      const variant = product.variants.find(x=>String(x.id)===specified) || product.variants.find(x=>x.available) || product.variants[0];
      await change('add', snapshot(product, variant));
      notice(storageFailed ? t.storage_error : t.added);
    }); } catch(error) { notice(error.code==='LIST_FULL' ? t.list_full : accountMode ? t.sync_error : t.save_error); } finally { button.disabled = false; }
  }
  function buttonFor(handle, cls='bwl-heart') {
    const button = el('button',cls); button.type='button'; button.dataset.bwlSave=handle; button.innerHTML=heart; button.setAttribute('aria-pressed','false'); button.setAttribute('aria-label',t.save); return button;
  }
  function scan() {
    document.querySelectorAll('.grid-product[data-product-handle]').forEach(card=>{
      const content=card.querySelector('.grid-product__content'),handle=card.dataset.productHandle;
      if(content && validHandle(handle) && !content.querySelector(':scope > [data-bwl-save]')) content.append(buttonFor(handle));
    });
    updateButtons();
  }
  async function render(fresh=false) {
    const grid=document.querySelector('[data-bwl-grid]'),empty=document.querySelector('[data-bwl-empty]');
    if(!grid) return;
    const restoreFocus=grid.contains(document.activeElement);
    const version=++renderVersion, current=items.slice();
    grid.setAttribute('aria-busy','true');
    empty.hidden=current.length>0 || accountMode && !authenticated;
    grid.hidden=!current.length;
    grid.replaceChildren();
    const cards=current.map(item=>{
      const article=el('article','bwl-card'); article.dataset.variantId=item.variantId;
      const imageLink=el('a','bwl-card__image'); imageLink.href=productURL(item); imageLink.setAttribute('aria-label',item.title);
      const imgURL=safeImage(item.image);
      if(imgURL){const img=el('img'); const u=new URL(imgURL);u.searchParams.set('width','540');img.src=u.href;img.alt=item.title;img.width=540;img.height=540;img.loading='lazy';imageLink.append(img);} else imageLink.append(el('span','bwl-card__placeholder','♡'));
      const remove=buttonFor(item.handle);remove.dataset.bwlVariant=item.variantId;
      const body=el('div','bwl-card__body');
      body.append(el('p','bwl-card__sku',`${t.bowl_number} ${item.sku || item.productId}`));
      let displayTitle=String(item.title).replace(/\s+Crystal Tones[®™]?\s+Alchemy Crystal Singing Bowl.*$/i,'');
      if(item.sku && displayTitle.endsWith(' '+item.sku))displayTitle=displayTitle.slice(0,-item.sku.length).trim();
      const title=el('h3'),link=el('a','',displayTitle);link.href=productURL(item);title.append(link);body.append(title);
      const stock=el('div','bwl-card__stock',t.loading); stock.dataset.state='loading';
      const price=el('p','bwl-card__price','');
      const actions=el('div','bwl-card__actions'),cartButton=el('button','bwl-button',t.add_cart);cartButton.type='button';cartButton.disabled=true;
      const recording=el('a','bwl-card__recording',t.recording);recording.href=productURL(item);
      const status=el('p','bwl-card__status');status.setAttribute('role','status');status.hidden=true;
      actions.append(cartButton,recording);body.append(stock,price,actions,status);article.append(imageLink,remove,body);grid.append(article);
      return {item,article,stock,price,cartButton,status};
    });
    updateButtons();
    if(restoreFocus)requestAnimationFrame(()=>{const target=grid.querySelector('[data-bwl-save]')||empty.querySelector('a');target?.focus({preventScroll:true});});
    await Promise.all(cards.map(async ({item,stock,price,cartButton,status})=>{
      try {
        const product=await getProduct(item.handle,fresh);
        if(version!==renderVersion)return;
        const variant=product?.variants.find(x=>String(x.id)===item.variantId);
        if(!variant || !variant.available){stock.textContent=t.unavailable;stock.dataset.state='unavailable';cartButton.textContent=t.unavailable;return;}
        stock.textContent=t.available;stock.dataset.state='available';
        price.textContent=new Intl.NumberFormat(c.locale,{style:'currency',currency:c.currency}).format(variant.price/100);
        cartButton.disabled=false;
        cartButton.addEventListener('click',()=>addCart(item,cartButton,status));
      }catch {if(version===renderVersion){stock.textContent=t.load_error;stock.dataset.state='error';cartButton.textContent=t.retry;cartButton.disabled=false;cartButton.addEventListener('click',()=>render(true),{once:true});}}
    }));
    if(version===renderVersion)grid.setAttribute('aria-busy','false');
  }
  async function addCart(item,button,status) {
    button.disabled=true;status.hidden=true;
    delete status.dataset.bwlCartSource;delete status.dataset.bwlCartSavedAt;
    try {
      const current=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'}).then(r=>{if(!r.ok)throw new Error();return r.json();});
      let line=current.items.find(x=>String(x.variant_id)===item.variantId);
      if(!line){
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:item.variantId,quantity:1,properties:{_bowls_i_love_source:'saved_list',_bowls_i_love_saved_at:item.savedAt}}]})});
        if(!response.ok)throw new Error('Cart unavailable');
        const added=await response.json();line=added.items?.find(x=>String(x.variant_id || x.id)===item.variantId);
      }
      status.dataset.bwlCartSource=line?.properties?._bowls_i_love_source==='saved_list' ? 'saved_list' : 'existing_cart';
      status.dataset.bwlCartSavedAt=line?.properties?._bowls_i_love_saved_at || '';
      button.textContent=t.in_cart;
      document.querySelectorAll('.cart-link__bubble').forEach(node=>node.classList.add('cart-link__bubble--visible'));
      const cartLink=el('a','bwl-card__recording',t.in_cart);cartLink.href=root+'cart';status.replaceChildren(cartLink);status.hidden=false;
      document.dispatchEvent(new CustomEvent('cart:build'));
    }catch{status.textContent=t.cart_error;status.hidden=false;button.disabled=false;cache.delete(item.handle);}
  }
  async function connect() {
    if(!c.syncEnabled || !account){syncMessage(t.preview_email);return;}
    if(connecting)return;
    connecting=true;
    document.querySelectorAll('[data-bwl-signin]').forEach(button=>button.disabled=true);
    syncMessage(t.connecting);
    try {await account.login();}catch{connecting=false;document.querySelectorAll('[data-bwl-signin]').forEach(button=>button.disabled=false);syncMessage(t.sync_error);}
  }
  async function signOut() {
    items=[];guestMemory=[];authenticated=false;undoItem=null;accountMode=false;
    updateButtons();render();syncMessage(t.signed_out);
    if(account)await account.logout();
  }
  async function loadAccount() {
    syncing=true;retrySaving=false;updateButtons();syncMessage(t.connecting);
    const guest=readGuest();
    let remote=null, pending=guest.slice();
    try {
      const data=await api();
      remote=normalize(data.items);
      for(const item of guest){
        const merged=await api('POST',{op:'import',item});
        remote=normalize(merged.items);
        pending=pending.filter(x=>x.variantId!==item.variantId);guestMemory=pending.slice();
        // This contains only the original guest choices, never account records.
        try{if(pending.length)localStorage.setItem(KEY,JSON.stringify(pending));else localStorage.removeItem(KEY);}catch{storageFailed=true;}
      }
      // Commit only after the full merge succeeds. Private account data never
      // becomes a guest list, including when storage is unavailable.
      authenticated=true;items=remote;guestMemory=[];
      try{localStorage.removeItem(KEY);}catch{storageFailed=true;}
      syncMessage(t.account_saved);
    } catch(error) {
      if(error.code==='LIST_FULL' && remote){authenticated=true;items=remote;syncMessage(t.merge_full);}
      else {authenticated=false;items=pending;retrySaving=Boolean(account?.hasSession());syncMessage(t.sync_error,error);throw error;}
    } finally {
      syncing=false;
      document.querySelectorAll('[data-bwl-save]').forEach(button=>button.disabled=false);
      updateButtons();await render(true);
    }
  }
  async function initialize() {
    items=readGuest();scan();render();
    if(accountMode)try{await loadAccount();}catch{}
    if(storageFailed)notice(t.storage_error);
  }
  document.addEventListener('click',event=>{
    const save=event.target.closest('[data-bwl-save]');if(save){event.preventDefault();event.stopPropagation();toggle(save);return;}
    if(event.target.closest('[data-bwl-dismiss]'))document.getElementById('bwl-notice').hidden=true;
    if(event.target.closest('[data-bwl-refresh]'))schedule(()=>accountMode ? loadAccount() : render(true)).catch(()=>{});
    if(event.target.closest('[data-bwl-retry-save]'))schedule(loadAccount).catch(()=>{});
    if(event.target.closest('[data-bwl-signin]'))connect();
    if(event.target.closest('[data-bwl-signout]'))signOut();
    if(event.target.closest('[data-bwl-undo]')&&undoItem){const item=undoItem;undoItem=null;schedule(()=>change('add',item)).then(()=>notice(t.added)).catch(()=>notice(t.save_error));}
    if(event.target.closest('[data-bwl-copy]'))copyList();
    if(event.target.closest('[data-bwl-select-copy]')){const field=document.getElementById('bwl-copy-text');if(field){field.focus();field.select();field.scrollTop=0;}}
  });
  window.addEventListener('storage',event=>{
    if(account?.isLogoutEvent(event.key)){account.clear();items=[];guestMemory=[];authenticated=false;undoItem=null;accountMode=false;updateButtons();render();syncMessage(t.signed_out);return;}
    if(account?.isChangeEvent(event.key)&&accountMode){schedule(loadAccount).catch(()=>{});return;}
    if(event.key===KEY&&!accountMode){items=readGuest();updateButtons();render();}
  });
  window.addEventListener('pagehide',()=>{if(accountMode){items=[];authenticated=false;updateButtons();render();}});
  window.addEventListener('pageshow',event=>{if(event.persisted&&accountMode)schedule(loadAccount).catch(()=>{});});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden&&accountMode&&!syncing)schedule(loadAccount).catch(()=>{});});
  let scanPending=false;
  new MutationObserver(records=>{if(records.some(r=>Array.from(r.addedNodes).some(n=>n.nodeType===1&&(n.matches?.('.grid-product')||n.querySelector?.('.grid-product'))))&&!scanPending){scanPending=true;requestAnimationFrame(()=>{scanPending=false;scan();});}}).observe(document.body,{childList:true,subtree:true});
  schedule(initialize);
})();
